import { Shimmer } from '@webmotors/eleanor-ui';
import { TAB_ORDER, MY_ADS_TEST_IDS, myAdsTestId } from '../../utils';
import { loadingStateStyles } from './loading-state.styles';
import type { TLoadingStateConfig } from './loading-state.types';

const TAB_SKELETON_WIDTHS = [72, 96, 80, 104] as const;

/**
 * Esqueleto que espelha o corpo do VehicleCard (desktop): imagem 156x156 à
 * esquerda, coluna de infos (título/versão/métricas/preço) e coluna de ações
 * (status + botão) à direita.
 */
const CardSkeleton = ({ index }: { index: number }) => (
	<div
		className={loadingStateStyles.card}
		data-testid={myAdsTestId.loadingSkeleton(index)}
		aria-hidden="true"
	>
		<Shimmer.Box width={156} height={156} borderRadius="large" />

		<div className={loadingStateStyles.cardInfo}>
			<Shimmer.Box width="55%" height={20} borderRadius="small" />
			<Shimmer.Box width="35%" height={14} borderRadius="small" />
			<Shimmer.Box width="45%" height={14} borderRadius="small" />
			<Shimmer.Box width={120} height={24} borderRadius="small" />
		</div>

		<div className={loadingStateStyles.cardActions}>
			<Shimmer.Box width={72} height={20} borderRadius="small" />
			<Shimmer.Box width={132} height={36} borderRadius="small" />
		</div>
	</div>
);

const LoadingState = ({ showTabs = true, showList = true }: TLoadingStateConfig) => (
	<div data-testid={MY_ADS_TEST_IDS.LOADING_STATE}>
		{showTabs && (
			<div className={loadingStateStyles.tabsRow} data-testid={MY_ADS_TEST_IDS.LOADING_TABS}>
				{TAB_ORDER.map((tabId, index) => (
					<Shimmer.Box
						key={tabId}
						width={TAB_SKELETON_WIDTHS[index] ?? 88}
						height={32}
						borderRadius="small"
						data-testid={myAdsTestId.loadingTabSkeleton(index)}
						aria-hidden="true"
					/>
				))}
			</div>
		)}
		{showList && (
			<div className={loadingStateStyles.listContainer}>
				{[0, 1, 2].map((i) => (
					<CardSkeleton key={i} index={i} />
				))}
			</div>
		)}
	</div>
);

LoadingState.displayName = 'LoadingState';

export { LoadingState };
